module.exports = __webpack_public_path__ + "static/media/clockcard.9b9e80d5.svg";